import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://jtjpfuksywqehfzpqjjn.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0anBmdWtzeXdxZWhmenBxampuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ1Nzc1MTAsImV4cCI6MjA3MDE1MzUxMH0.GOWrlUhnTPjN3YWO8syXwzP4jY6tGaeI7H21dVfQZjY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

export default supabase;